module.exports = __webpack_public_path__ + "img/bamboo.37dea5e.webp";